import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Meta from "vue-meta";
import { getEnvVariable } from "@/api/axios";

Vue.use(VueRouter);
Vue.use(Meta);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home/Home.vue"),
    async beforeEnter(to, from, next) {
      const VUE_APP_IS_PRODUCTION = await getEnvVariable("VUE_APP_IS_PRODUCTION");

      VUE_APP_IS_PRODUCTION === "true"
        ? window.location.href = "https://saude.clinicarx.com.br"
        : next()
    }
  },
  { //TODO analise posterior para remoção dessa rota
    path: "/r/:serviceName",
    name: "SearchServices",
    component: () => import("@/views/ClinicsResult/ClinicsResult.vue"),
    props: true,
  },
  { //TODO analise posterior para remoção dessa rota
    path: "/r/:slugId",
    name: "SearchServicesTenancy",
    component: () => import("@/views/ClinicsResult/ClinicsResult.vue"),
    props: true,
  },
  {
    path: "/onde-encontrar/:slugId/:clinicId",
    name: "ClinicScreen",
    component: () => import("@/views/ClinicScreen/HomeClinic.vue"),
  },
  {
    path: "/search-error",
    name: "SearchError",
    component: () => import("@/views/SearchError.vue"),
  },
  {
    path: "/onde-encontrar/:slugId",
    name: "Tenancy",
    component: () => import("@/views/Home/Home.vue"),
  },
  {
    path: "/search/:fileName",
    name: "SEOSearchServicesTenancy",
    component: () => import("@/views/ClinicsResult/ClinicsResult.vue"),
    props: true,
  },
  {
    path: "/avaliacao/atendimento/:appointmentId/:rating/:env",
    name: "RatingPage",
    component: () => import("@/views/Rating/RatingPage.vue"),
  },
  {
    path: "/iframe/search-bar",
    name: "SearchBarIframe",
    component: () => import("@/views/SearchBarIframe/SearchBarIframe.vue"),
  },
  {
    path: "*",
    name: "NotFoundPage",
    component: () => import("@/views/NotFound/NotFoundPage.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
